/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';
import SectionsIcon from 'icons/SectionsIcon';

const messages = defineMessages({
  title: {id: 'navigation.sections'},
});

const SectionsItem = () => (
  <RouteLinkItem
    iconBefore={SectionsIcon}
    route="midas/students/sections"
    title={messages.title}
  />
);

export default SectionsItem;
